import { connector as api_companydb } from "@/api/connector";
import { getField, updateField } from 'vuex-map-fields';

export const SET_PERMISSION = "SET_PERMISSION";

class Permission {
    constructor({ id, role_kind, is_owner, is_readonly, is_writer, is_invited, can_write, general, is_employee}) {
        this.id = id;
        this.role_kind = role_kind;
        this.is_owner = is_owner;
        this.is_readonly = is_readonly;
        this.is_writer = is_writer;
        this.is_invited = is_invited;
        this.can_write = can_write;
        this.general = general;
        this.is_employee = is_employee;
    }
}

const defaultValues = { 
    id: false, 
    role_kind: false, 
    is_owner: false, 
    is_readonly: false, 
    is_writer: false, 
    is_invited: false, 
    can_write: false,
    general: {
        is_organization: false,
        companydb_actividad: false,
        can_admin: false,
        is_customer_consult: false
    },
    is_employee: false
}

const state = {
    permission: new Permission(defaultValues)
}

const getPermissions = async (context, companydbId) => {
    let promise = new Promise((resolve, reject) => {
        api_companydb.getPermissions({ id: companydbId }).then(response => {
            context.commit(SET_PERMISSION, response.data);
            resolve(response);
        }, error => {
            reject(error);
        });
    });
    return promise;
}

const actions = {
    getPermissions,
}

const getters = {
    permission: state => state.permission,
    getField
}

const mutations = {
    [SET_PERMISSION](state, data) {
        state.permission = new Permission(data);
    },
    updateField,
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  }